/**
 * @generated SignedSource<<122ff605c1986738847b2c58892375d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskSellerItemTile_viewer$data = {
  readonly item?: {
    readonly dealerReference: string | null;
    readonly dealerStatusDisplay: string | null;
    readonly dibsReference: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "GetHelpZendeskSellerItemTile_viewer";
};
export type GetHelpZendeskSellerItemTile_viewer$key = {
  readonly " $data"?: GetHelpZendeskSellerItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskSellerItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasItemId"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskSellerItemTile_viewer",
  "selections": [
    {
      "condition": "hasItemId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": "small"
                }
              ],
              "kind": "ScalarField",
              "name": "firstPhotoWebPath",
              "storageKey": "firstPhotoWebPath(size:\"small\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dealerReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dibsReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dealerStatusDisplay",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b0f30a6360553d621ffdbd9b1686e8fc";

export default node;
